import { BareButton } from '@calendly/ui/components/bare-button';
import { CloseIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { forwardRef } from 'react';
const closeButtonCss = "cldyvbe";
export const CloseButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(closeButtonCss, props.className)}>
    <CloseIcon />
  </BareButton>);

require("./close-button.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./close-button.js");